<template>
  <div class="countList-wrap">
    <img
      :src="require(`@/assets/images/largeScreen/${props.item.bg}.png`)"
      alt=""
    />
    <div class="countList-content">
      <div class="countList-titile">{{ props.item.title }}</div>
      <div class="countList-count">
        <CountUp
          :startVal="0"
          :endVal="props.data ? props.data : 0"
          :index="`countList_${props.item.key}`"
        />
        <span>
          {{ props.item.key === 'assetsNumRate' ? '%' : '' }}
        </span>
        <!-- {{
          `${props.data || 0}`
        }} -->
        <!-- <CountUp
          :startVal="0"
          :endVal="props.data ? props.data : 0"
          :index="`countList_${props.item.key}`"
        /> -->
      </div>
    </div>
  </div>
</template>

<script>
import CountUp from "@/components/common/countup.vue";
export default {
  props: {
    data: Object,
    item: Object,
  },
  components: {
    CountUp
  },
  setup(props) {

    return {
      props,
    };

  }
}
</script>

<style scoped lang="less">
@import url('./index.less');
</style>
